import {Component} from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)

    this.state = {hasError: false}
  }

  static getDerivedStateFromError(error) {
    return {hasError: !!error}
  }

  componentDidCatch(error, info) {
    if (__DEV__)
      console.error(error)

    console.info(info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback
    } else {
      return this.props.children
    }
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.node
}

export default ErrorBoundary
